<script lang="ts" setup>
import { computed } from 'vue';

interface Props {
    isOpen: boolean;
    openLabel?: string;
    closedLabel?: string;
    dataId?: string;
}

const props = withDefaults(defineProps<Props>(), {
    openLabel: 'Hide',
    closedLabel: 'Show',
    dataId: '',
});

const emit = defineEmits<{
    toggle: [];
}>();

const buttonLabel = computed(() =>
    props.isOpen ? props.openLabel : props.closedLabel,
);

const handleClick = () => {
    emit('toggle');
};
</script>

<template>
    <app-button
        class="expand-collapse-toggle"
        :class="{ 'expand-collapse-toggle--open': isOpen }"
        :data-id="dataId"
        icon="cd-ic-caret-down"
        icon-position="right"
        expanded
        size="large"
        @on-click="handleClick"
    >
        {{ buttonLabel }}
    </app-button>
</template>

<style lang="scss" scoped>
@use "certifid-v2-client-hub-styles" as *;

.expand-collapse-toggle {
    padding: 0.75rem 1rem !important;
    background: var(--ch-primary-dark) !important;
    color: $white !important;
    border-radius: 0.375rem;
    font-size: 0.9rem !important;
    font-weight: 700 !important;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);

    &:hover {
        background: var(--ch-primary-dark) !important;
        opacity: 0.95;
    }

    &--open.app-button {
        border-radius: 0.375rem 0.375rem 0 0;
    }

    :deep(.app-button__content) {
        flex: 1;
        justify-content: center;
        position: relative;
    }

    :deep(.app-button__icon) {
        position: absolute;
        right: 0;
        flex-shrink: 0;
        width: 1.5rem;
        height: 1.5rem;
        color: $white;
        transition: transform 0.2s ease;
    }

    &--open :deep(.app-button__icon) {
        transform: rotate(180deg);
    }
}
</style>
